import PropTypes from "prop-types";
import { useFormContext, useWatch } from "react-hook-form";

import { Switch } from "@/components/ui/switch";

/**
 * A radio across a field array: turning one row's primary on turns the rest
 * off, so at most one row is ever primary.
 */
export const PrimaryToggle = ({ arrayName, index, label }) => {
  const { control, getValues, setValue } = useFormContext();
  const checked = useWatch({
    control,
    name: `${arrayName}.${index}.is_primary`,
  });

  const handleCheckedChange = next => {
    if (next) {
      getValues(arrayName).forEach((_, i) =>
        setValue(`${arrayName}.${i}.is_primary`, i === index)
      );
    } else {
      setValue(`${arrayName}.${index}.is_primary`, false);
    }
  };

  return (
    <Switch
      checked={Boolean(checked)}
      aria-label={label}
      onCheckedChange={handleCheckedChange}
    />
  );
};

PrimaryToggle.propTypes = {
  arrayName: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
};

/**
 * Removes a row. When it held the primary flag, the first remaining row
 * becomes primary, as in the legacy editors.
 */
export const useRemoveKeepingPrimary = (arrayName, remove) => {
  const { getValues, setValue } = useFormContext();
  return index => {
    const wasPrimary = Boolean(getValues(`${arrayName}.${index}.is_primary`));
    remove(index);
    if (wasPrimary && getValues(arrayName).length > 0) {
      setValue(`${arrayName}.0.is_primary`, true);
    }
  };
};
